import { vsComponentName } from "./component";

export const vsServiceName =
  "machineConfigurationTypeSubmitOptionsModalService";

export class MachineConfigurationTypeSubmitOptionsModalService {
  static $inject = ["$uibModal"];
  constructor(private readonly $uibModal: angular.ui.bootstrap.IModalService) {}

  openModal() {
    return this.$uibModal.open({
      component: vsComponentName,
    }).result;
  }
}
